import parse from 'html-react-parser';
import { useTranslate } from 'hooks/useTranslate';
import { getDateTime } from 'modules/communications/components/utils';
import { useCommunicationDetailsPage } from '../context/CommunicationDetailsPageContext';

const CommunicationDataSection = () => {
  const { t } = useTranslate();
  const { data } = useCommunicationDetailsPage();
  const { communication } = data;

  const parsedBody = communication?.body ? parse(communication.body) : '';
  const date = communication?.date ? getDateTime(communication.date) : '';

  return (
    <div className="cm-data">
      <div className="cm-data__meta">
        <div className="cm-data__sender">
          <div className="cm-data__sender-avatar">
            {communication?.sender?.email?.[0]?.toUpperCase() || '?'}
          </div>
          <div>
            <span className="cm-data__sender-label">{t('EmailFrom')}</span>
            <span className="cm-data__sender-email">
              {communication?.sender?.email}
            </span>
          </div>
        </div>
        <div className="cm-data__meta-right">
          {data.attachedDocuments?.length > 0 && (
            <em className="icon ni ni-clip-h cm-data__clip-icon" />
          )}
          <span className="cm-data__date">{date}</span>
        </div>
      </div>

      <div className="cm-data__body">
        <div
          style={{
            whiteSpace: typeof parsedBody === 'string' ? 'pre-line' : 'normal',
          }}
        >
          {parsedBody || ''}
        </div>
      </div>
    </div>
  );
};

export default CommunicationDataSection;
